<template>
    <div>
        <div class="header">
            <div class="header_t">
                <p class="header_tf">CDN全场5折起</p>
                <span class="header_ttw">CDN流量0.05/G</span>
                <div class="topFontTh">国内1000+节点智能分发，最高业务带宽峰值可达T级</div>
                <el-button
				@click="shopping"
                    type="primary"
                    class="header-title"
                    style="color:#fff;background: #0066FF;width: 108px;height: 42px;"
                >立即加入</el-button>
            </div>
            <img src="../assets/imgs/latestTwo.png" class="fruit_img">
        </div>
        <!-- 促销流量包 -->
        <div class="content_t" >
            <el-row>
                <el-col :xs="24" :sm="24">
                    <div class="product_pc_one">
                        <div class="product_pc">
                            <div class="product_pct">促销流量包</div>
                            <div class="total_list">
                                <div class="total_list_detail" style="">
                                    <div class="total_list_detail_t">
                                        <p>入门型</p>
                                        <span>适合日流量小于 1500 MB 的小型网站</span>
                                    </div>
                                    <div class="total_list_detail_c">
                                        <p class="total_list_detail_cp">
                                            国内静态加速流量
                                            <span>1024 GB</span>
                                        </p>
                                        <span
                                            class="total_list_detail_csp"
                                        >一次性发放，一月有效 适用时段: 全时段可用 支持协议: HTTP/HTTPS</span>
                                        <p class="total_list_detail_cpp">
                                            0.00
                                            <span>元/月</span>
                                        </p>
                                        <el-button
										@click="shopping"
                                            type="primary"
                                            class="header-title"
                                            style="color:#fff;background: #0066FF;width: 295px;
                                            height: 48px;margin: 50px 0 10px 0;font-size: 20px;"
                                        >立即领取</el-button>
                                    </div>
                                </div>
                                <div class="total_list_detail">
                                    <div class="total_list_detail_t">
                                        <p>进阶型</p>
                                        <span>适合日下行流量小于 3 GB 的小型网站</span>
                                    </div>
                                    <div class="total_list_detail_c">
                                        <p class="total_list_detail_cp">
                                            国内静态加速流量
                                            <span>5 TB</span>
                                        </p>
                                        <span
                                            class="total_list_detail_csp"
                                        >一次性发放，一月有效 适用时段: 全时段可用 支持协议: HTTP/HTTPS</span>
                                        <p class="total_list_detail_cpp">
                                            0.00
                                            <span>元/月</span>
                                        </p>
                                        <el-button
										@click="shopping"
                                            type="primary"
                                            class="header-title"
                                            style="color:#fff;background: #0066FF;width: 295px;
                                            height: 48px;margin: 50px 0 10px 0;font-size: 20px;"
                                        >立即领取</el-button>
                                    </div>
                                </div>
                                <div class="total_list_detail">
                                    <div class="total_list_detail_t">
                                        <p>企业型</p>
                                        <span>适合日下行流量小于 15 GB 的小型网站</span>
                                    </div>
                                    <div class="total_list_detail_c">
                                        <p class="total_list_detail_cp">
                                            国内静态加速流量
                                            <span>10 TB</span>
                                        </p>
                                        <span
                                            class="total_list_detail_csp"
                                        >一次性发放，一月有效 适用时段: 全时段可用 支持协议: HTTP/HTTPS</span>
                                        <p class="total_list_detail_cpp">
                                            980.00
                                            <span>元/月</span>
                                        </p>
                                        <el-button
										@click="shopping"
                                            type="primary"
                                            class="header-title"
                                            style="color:#fff;background: #0066FF;width: 295px;
                                            height: 48px;margin: 50px 0 10px 0;font-size: 20px;"
                                        >立即购买</el-button>
                                    </div>
                                </div>
                                <div class="total_list_detail">
                                    <div class="total_list_detail_t">
                                        <p>专业型</p>
                                        <span>适合日下行流量小于 30 GB 的小型网站</span>
                                    </div>
                                    <div class="total_list_detail_c">
                                        <p class="total_list_detail_cp">
                                            国内静态加速流量
                                            <span>30 TB</span>
                                        </p>
                                        <span
                                            class="total_list_detail_csp"
                                        >一次性发放，一月有效 适用时段: 全时段可用 支持协议: HTTP/HTTPS</span>
                                        <p class="total_list_detail_cpp">
                                            2800.00
                                            <span>元/月</span>
                                        </p>
                                        <el-button
										@click="shopping"
                                            type="primary"
                                            class="header-title"
                                            style="color:#fff;background: #0066FF;width: 295px;
                                            height: 48px;margin: 50px 0 10px 0;font-size: 20px;"
                                        >立即购买</el-button>
                                    </div>
                                </div>
                                <div class="total_list_detail">
                                    <div class="total_list_detail_t">
                                        <p>电商型</p>
                                        <span>适合图片详情页比较多，访问人流量比较大的电商平台</span>
                                    </div>
                                    <div class="total_list_detail_c">
                                        <p class="total_list_detail_cp">
                                            国内静态加速流量
                                            <span>50 TB</span>
                                        </p>
                                        <span
                                            class="total_list_detail_csp"
                                        >一次性发放，一年有效 适用时段: 全时段可用 支持协议: HTTP/HTTPS</span>
                                        <p class="total_list_detail_cpp">
                                            4300.00
                                            <span>元/年</span>
                                        </p>
                                        <el-button
										@click="shopping"
                                            type="primary"
                                            class="header-title"
                                            style="color:#fff;background: #0066FF;width: 295px;
                                            height: 48px;margin: 50px 0 10px 0;font-size: 20px;"
                                        >立即购买</el-button>
                                    </div>
                                </div>
                                <div class="total_list_detail">
                                    <div class="total_list_detail_t">
                                        <p>下载型</p>
                                        <span>适合大型资源站、文件在线下载高并发负载</span>
                                    </div>
                                    <div class="total_list_detail_c">
                                        <p class="total_list_detail_cp">
                                            国内静态加速流量
                                            <span>100 TB</span>
                                        </p>
                                        <span
                                            class="total_list_detail_csp"
                                        >一次性发放，一年有效 适用时段: 全时段可用 支持协议: HTTP/HTTPS</span>
                                        <p class="total_list_detail_cpp">
                                            8800.00
                                            <span>元/年</span>
                                        </p>
                                        <el-button
										@click="shopping"
                                            type="primary"
                                            class="header-title"
                                            style="color:#fff;background: #0066FF;width: 295px;
                                            height: 48px;margin: 50px 0 10px 0;font-size: 20px;"
                                        >立即购买</el-button>
                                    </div>
                                </div>
                                <div class="total_list_detail">
                                    <div class="total_list_detail_t">
                                        <p>视频型</p>
                                        <span>适合大流量视频点播，多用户观看平台</span>
                                    </div>
                                    <div class="total_list_detail_c">
                                        <p class="total_list_detail_cp">
                                            国内静态加速流量
                                            <span>200 TB</span>
                                        </p>
                                        <span
                                            class="total_list_detail_csp"
                                        >一次性发放，一年有效 适用时段: 全时段可用 支持协议: HTTP/HTTPS</span>
                                        <p class="total_list_detail_cpp">
                                            17000.00
                                            <span>元/年</span>
                                        </p>
                                        <el-button
										@click="shopping"
                                            type="primary"
                                            class="header-title"
                                            style="color:#fff;background: #0066FF;width: 295px;
                                            height: 48px;margin: 50px 0 10px 0;font-size: 20px;"
                                        >立即购买</el-button>
                                    </div>
                                </div>
                                <div class="total_list_detail">
                                    <div class="total_list_detail_t">
                                        <p>定制型</p>
                                        <span>适合大流量访问，APP或大型网站平台</span>
                                    </div>
                                    <div class="total_list_detail_c">
                                        <p class="total_list_detail_cp">
                                            国内静态加速流量
                                            <span>1 PB</span>
                                        </p>
                                        <span
                                            class="total_list_detail_csp"
                                        >一次性发放，一年有效 适用时段: 全时段可用 支持协议: HTTP/HTTPS</span>
                                        <p class="total_list_detail_cpp">
                                            55000.00
                                            <span>元/年</span>
                                        </p>
                                        <el-button
										@click="shopping"
                                            type="primary"
                                            class="header-title"
                                            style="color:#fff;background: #0066FF;width: 295px;
                                            height: 48px;margin: 50px 0 10px 0;font-size: 20px;"
                                        >立即购买</el-button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <!-- 国内外优质节点覆盖 -->
        <div class="bottom_map">
            <el-row>
                <el-col :xs="24" :sm="24">
                    <div class="product_pc_one">
                        <div class="product_pc">活动规则</div>
                        <div class="product_pc_b">
                            <div v-for="(item,index) in detailList" :key="index">
                                <span>{{item}}</span>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
export default {
  name: "Fruit",
  data() {
    return {
      detailList: [
          "1.活动时间：2023年2月1日-2023年6月30日。",
        "2.活动适用人群：所有易凡云注册用户。",
        "3.本次活动流量包仅限于中国大陆地区域名加速。",
        " 4.未备案域名不能使用本次活动流量包，可联系客服申请易凡云海外cdn产品。",
        "  5.支付方式支持预充值余额扣费和支付宝直接支付。",
        "6.活动流量包有效期：自购买之日起，按照活动规定。",
        "7.参与活动的用户应同时遵守易凡云官网所示的《用户服务协议》、产品相关的协议及页面使用规则。"
      ]
    };
  },
  methods: {
  		shopping(){
  	 window.open("https://cdn-admin.yifancloud.cn/plan/purchase");
  },
   }
};
</script>

<style scoped>
.topFontTh {
  font-size: 20px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: 24px;
  margin-bottom: 41px;
}
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.header {
  position: relative;
}
.header .header_t {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 80px;
  left: 348px;
    animation: header_t 2s;
}

@keyframes header_t {
  0% {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
}
.header .header_t .header_tf {
  font-size: 32px;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #000000;
  line-height: 24px;
}
.header .header_t .header_ttw {
  font-size: 40px;
  font-weight: 600;
  color: #0066ff;
  line-height: 40px;
  margin: 23px 0;
  letter-spacing: 5px;
}
.header .header_t .header_b {
  display: flex;
  flex-direction: column;
  font-size: 18px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #000000;
  line-height: 40px;
}
.header .fruit_img {
  height: 376px;
  width: 100%;
}
.content_t {
  height: 1450px;
  background: #f5f7fd;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  margin-top: -10px
}
.content_t .product_pc_one {
  position: relative;
}
.content_t .product_pc_one .product_pc {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

}
.content_t .product_pc_one .product_pc .product_pct {
  font-size: 36px;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #000000;
  line-height: 48px;
  margin: 66px 0 66px 0;
}
.content_t .product_pc_one .product_pc .total_list {
  display: flex;
  flex-wrap: wrap;
  width: 1346px;
  height: 1070px;
  justify-content: space-around;
    animation: total_list 2s;
}

@keyframes total_list {
  0% {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
}
.content_t
  .product_pc_one
  .product_pc
  .total_list
  .total_list_detail
  .total_list_detail_t {
  position: relative;
  background-image: url("../assets/imgs/priceNine.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 315px;
  height: 149px;
  position: relative;
}
.content_t
  .product_pc_one
  .product_pc
  .total_list
  .total_list_detail
  .total_list_detail_t
  p {
  font-size: 20px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #ffffff;
  line-height: 20px;
  position: absolute;
  top: 21%;
  left: 8%;
}
.content_t
  .product_pc_one
  .product_pc
  .total_list
  .total_list_detail
  .total_list_detail_t
  span {
  width: 261px;
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 24px;
  position: absolute;
  bottom: 17%;
  left: 8%;
}
.content_t
  .product_pc_one
  .product_pc
  .total_list
  .total_list_detail
  .total_list_detail_c {
  width: 315px;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 50px;
}
.content_t
  .product_pc_one
  .product_pc
  .total_list
  .total_list_detail
  .total_list_detail_c
  .total_list_detail_cp {
  font-size: 16px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #282c33;
  margin-top: 28px;
}
.content_t
  .product_pc_one
  .product_pc
  .total_list
  .total_list_detail
  .total_list_detail_c
  .total_list_detail_cp
  span {
  color: #ff6b00;
}
.content_t
  .product_pc_one
  .product_pc
  .total_list
  .total_list_detail
  .total_list_detail_c
  .total_list_detail_csp {
  width: 153px;
  font-size: 14px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #282c33;
  line-height: 38px;
  margin: 28px 0 45px 0;
}
.content_t
  .product_pc_one
  .product_pc
  .total_list
  .total_list_detail
  .total_list_detail_c
  .total_list_detail_cpp {
  font-size: 40px;
  font-family: PingFang SC-Bold, PingFang SC;
  font-weight: bold;
  color: #ff6b00;
  line-height: 16px;
}
.content_t
  .product_pc_one
  .product_pc
  .total_list
  .total_list_detail
  .total_list_detail_c
  .total_list_detail_cpp
  span {
  font-size: 16px;
  margin-left: -10px;
}
.bottom_map {
  height: 637px;
  padding-top: 90px;
}
.bottom_map .product_pc_one {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.bottom_map .product_pc_one .product_pc {
  width: 1025px;
  height: 63px;
  background: #0066ff;
  border-radius: 10px 10px 0px 0px;
  font-size: 24px;
  font-family: PingFang SC-Heavy, PingFang SC;
  font-weight: 800;
  color: #ffffff;
  line-height: 24px;
  display: flex;
  align-items: center;
  justify-content: space-around;
}
.bottom_map .product_pc_one .product_pc_b {
  display: flex;
  align-items: center;
  flex-direction: column;
  background-image: url("../assets/imgs/latestOne.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  width: 1025px;
  height: 409px;
  justify-content: center;
}
.bottom_map .product_pc_one .product_pc_b div {
  width: 721px;
  font-size: 16px;
  font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #282c33;
  line-height: 40px;
}
</style>